module.exports = __webpack_public_path__ + "static/media/classicDisabled.1f4ab50f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/classicDisabled.svg
// module id = 1199
// module chunks = 71